/** Clé d'idempotence (UUID v4) : un renvoi après une erreur réseau ne crée pas de doublon côté serveur */
export function nouvelleClientRef(): string {
  const c: any = (globalThis as any).crypto;
  if (c?.randomUUID) { return c.randomUUID(); }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, ch => {
    const r = Math.random() * 16 | 0;
    return (ch === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
